<template>
	<div class="ttshop_user">
		<Header></Header>
		<Userheader></Userheader>
		<div class="ttshop_user">
			<div class="ttshop_usercon w clearfloat">
				<!-- 个人中心导航 -->
				<Usernavleft></Usernavleft>
				<div class="ttshop_useright">
					<!-- 我的积分 列表-->
					<div class="ttshop_balance">
						<div class="ttshop_balanceup clearfloat">
							<div class="ttshop_balanceupleft">
								<h5>我的积分</h5>
								<h4>30000</h4>
							</div>
						</div>
						<!-- 暂无积分消费记录 -->
						<div class="ttshop_zuxiaofei">
							<img class="img-default" src="../../assets/images/ttshop_zanwu.png" alt="">
							<p>您目前暂无积分消费记录</p>
						</div>
						<div class="ttshop_balancebut">
							<div class="ttshop_balancetitle clearfloat">
								<div class="ttshop_balanleft">
									<div class="ttshop_myordertexter clearfloat">
										<el-dropdown>
											<p>近三个月订单</p><i><img class="img-default" src="../../assets/images/ttshop_orderxl.png" alt=""></i>
											<el-dropdown-menu slot="dropdown">
												<el-dropdown-item>昨天</el-dropdown-item>
												<el-dropdown-item>近一周</el-dropdown-item>
												<el-dropdown-item>近一个月</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown>
									</div>
								</div>
								<div class="ttshop_balanconter">
									<div class="ttshop_myorderzts  clearfloat">
										<el-dropdown>
											<p>全部类型</p><i><img class="img-default" src="../../assets/images/ttshop_orderxl.png" alt=""></i>
										    <el-dropdown-menu slot="dropdown">
												<el-dropdown-item>购买商品</el-dropdown-item>
												<el-dropdown-item>充值</el-dropdown-item>
										    </el-dropdown-menu>
										</el-dropdown>
									</div>
								</div>
								<div class="ttshop_balanlast">
									<p>积分</p>
								</div>
							</div>
							<div class="ttshop_balanlist">
								<ul>
									<li class="clearfloat">
										<p class="ttshop_balantime">2020-08-30 12:39</p>
										<p class="ttshop_balantext">购买商品</p>
										<p class="ttshop_balanlistlast">-30.00</p>
									</li>
									<li class="clearfloat">
										<p class="ttshop_balantime">2020-08-30 12:39</p>
										<p class="ttshop_balantext">充值</p>
										<p class="ttshop_balanlistlast">+3000.00</p>
									</li>
									<li class="clearfloat">
										<p class="ttshop_balantime">2020-08-30 12:39</p>
										<p class="ttshop_balantext">购买商品</p>
										<p class="ttshop_balanlistlast">-30.00</p>
									</li>
									<li class="clearfloat">
										<p class="ttshop_balantime">2020-08-30 12:39</p>
										<p class="ttshop_balantext">购买商品</p>
										<p class="ttshop_balanlistlast">-30.00</p>
									</li>
									<li class="clearfloat">
										<p class="ttshop_balantime">2020-08-30 12:39</p>
										<p class="ttshop_balantext">充值</p>
										<p class="ttshop_balanlistlast">+3000.00</p>
									</li>
									<li class="clearfloat">
										<p class="ttshop_balantime">2020-08-30 12:39</p>
										<p class="ttshop_balantext">购买商品</p>
										<p class="ttshop_balanlistlast">-30.00</p>
									</li>
									<li class="clearfloat">
										<p class="ttshop_balantime">2020-08-30 12:39</p>
										<p class="ttshop_balantext">购买商品</p>
										<p class="ttshop_balanlistlast">-30.00</p>
									</li>
									<li class="clearfloat">
										<p class="ttshop_balantime">2020-08-30 12:39</p>
										<p class="ttshop_balantext">充值</p>
										<p class="ttshop_balanlistlast">+3000.00</p>
									</li>
									<li class="clearfloat">
										<p class="ttshop_balantime">2020-08-30 12:39</p>
										<p class="ttshop_balantext">购买商品</p>
										<p class="ttshop_balanlistlast">-30.00</p>
									</li>
									<li class="clearfloat">
										<p class="ttshop_balantime">2020-08-30 12:39</p>
										<p class="ttshop_balantext">购买商品</p>
										<p class="ttshop_balanlistlast">-30.00</p>
									</li>
								</ul>
							</div>
							<div class="ttshop_myorderpage clearfloat">
								<el-pagination class="ttshop_pages" background layout="prev, pager, next" :total="40"></el-pagination>
							</div>
						</div>
					</div>
					<!-- 积分商城 -->
					<div class="ttshop_integral">
						<div class="ttshop_integraltitle clearfloat">
							<h4>积分商城</h4>
							<router-link to="/">查看更多</router-link>
						</div>
						<div class="ttshop_integralist">
							<ul class="clearfloat">
								<li>
									<div class="ttshop_integralimg">
										<img class="img-default" src="../../assets/images/goods_1.png" alt="">
									</div>
									<div class="ttshop_integraltext">
										<h5>GXG男装2020年夏季白色短袖T恤男士潮牌潮流体恤卡通衣服</h5>
										<p><span class="ttshop_integraljf"><strong>2000</strong>积分</span><i></i><span class="ttshop_integralmoney">￥65.00</span></p>
									</div>
								</li>
								<li>
									<div class="ttshop_integralimg">
										<img class="img-default" src="../../assets/images/goods_1.png" alt="">
									</div>
									<div class="ttshop_integraltext">
										<h5>GXG男装2020年夏季白色短袖T恤男士潮牌潮流体恤卡通衣服</h5>
										<p><span class="ttshop_integraljf"><strong>2000</strong>积分</span><i></i><span class="ttshop_integralmoney">￥65.00</span></p>
									</div>
								</li>
								<li>
									<div class="ttshop_integralimg">
										<img class="img-default" src="../../assets/images/goods_1.png" alt="">
									</div>
									<div class="ttshop_integraltext">
										<h5>GXG男装2020年夏季白色短袖T恤男士潮牌潮流体恤卡通衣服</h5>
										<p><span class="ttshop_integraljf"><strong>2000</strong>积分</span><i></i><span class="ttshop_integralmoney">￥65.00</span></p>
									</div>
								</li>
								<li>
									<div class="ttshop_integralimg">
										<img class="img-default" src="../../assets/images/goods_1.png" alt="">
									</div>
									<div class="ttshop_integraltext">
										<h5>GXG男装2020年夏季白色短袖T恤男士潮牌潮流体恤卡通衣服</h5>
										<p><span class="ttshop_integraljf"><strong>2000</strong>积分</span><i></i><span class="ttshop_integralmoney">￥65.00</span></p>
									</div>
								</li>
								<li>
									<div class="ttshop_integralimg">
										<img class="img-default" src="../../assets/images/goods_1.png" alt="">
									</div>
									<div class="ttshop_integraltext">
										<h5>GXG男装2020年夏季白色短袖T恤男士潮牌潮流体恤卡通衣服</h5>
										<p><span class="ttshop_integraljf"><strong>2000</strong>积分</span><i></i><span class="ttshop_integralmoney">￥65.00</span></p>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>	
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Foot from "@/components/foot/foot";
	import Userheader from "./components/user_index";
	import Usernavleft from "./components/user_navleft";
	export default {
		components: {
			Header,
			Userheader,
			Usernavleft,
			Foot,
		},
		data() {
			return {
				
			}
		},
		mounted(){
			
		}
	};
</script>

<style  lang="scss" scoped>
	.ttshop_balance{
		width: 100%;
		background: #fff;
		padding-bottom: 35px;
		box-sizing: border-box;
		margin-bottom: 10px;
		.ttshop_balanceup{
			width: 100%;
			padding: 40px;
			box-sizing: border-box;
			.ttshop_balanceupleft{
				float: left;
				margin-right: 70px;
				h5{
					font-size: 16px;
					color: #666;
					font-weight: 500;
					line-height: 16px;
					margin-bottom: 12px;
				}
				h4{
					font-size: 32px;
					color: #666;
					font-weight: 600;
					line-height: 32px;
				}
			}
			.ttshop_balanceupright{
				float: left;
				padding-top: 14px;
				box-sizing: border-box;
				a{
					display: block;
					width: 116px;
					height: 32px;
					border-radius: 2px;
					text-align: center;
					line-height: 32px;
					font-size: 14px;
					color: #fff;
					background: #FF0E25;
					transition: .5s;
					-moz-transition: .5s;
					-webkit-transition: .5s;
					-o-transition: .5s;
					&:hover{
						box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
					}
				}
			}
		}
		.ttshop_zuxiaofei{
			width: 100%;
			padding-top: 150px;
			display: none;
			box-sizing: border-box;
			img{
				display: block;
				width: 93px;
				height: 80px;
				margin: 0 auto 20px;
			}
			p{
				font-size: 16px;
				color: #333;
				text-align: center;
			}
		}
		.ttshop_balancebut{
			width: 100%;
			padding: 0 24px;
			box-sizing: border-box;
			.ttshop_balancetitle{
				width: 100%;
				height: 32px;
				background: #F5F5F5;
				.ttshop_balanleft{
					float: left;
					width: 45%;
					padding-left: 24px;
					padding-top: 8px;
					box-sizing: border-box;
					.ttshop_myordertexter{
						display: table;
						cursor: pointer;
						position: relative;
						p{
							float: left;
							font-size: 12px;
							color: #333;
						}
						i{
							float: left;
							width: 12px;
							height: 12px;
							margin-top: 2px;
							img{
								display: block;
								width: 100%;
							}
						}
					}
				}
				.ttshop_balanconter{
					float: left;
					width: 30%;
					padding-top: 8px;
					box-sizing: border-box;
					.ttshop_myorderzts{
						cursor: pointer;
						p{
							float: left;
							font-size: 12px;
							color: #333;
						}
						i{
							float: left;
							width: 12px;
							height: 12px;
							margin-top: 2px;
							img{
								display: block;
								width: 100%;
							}
						}
					}
				}
				.ttshop_balanlast{
					float: left;
					width: 25%;
					padding-top: 8px;
					padding-right: 24px;
					box-sizing: border-box;
					p{
						font-size: 12px;
						color: #333;
						text-align: right;
					}
				}
			}
			.ttshop_balanlist{
				width: 100%;
				ul{
					li{
						width: 100%;
						height: 40px;
						border: 1px solid #EBEBEB;
						border-top: 0;
						box-sizing: border-box;
						line-height: 40px;
						.ttshop_balantime{
							float: left;
							width: 45%;
							padding-left: 24px;
							box-sizing: border-box;
							font-size: 12px;
							color: #333;
						}
						.ttshop_balantext{
							float: left;
							width: 30%;
							font-size: 12px;
							color: #333;
						}
						.ttshop_balanlistlast{
							float: left;
							width: 25%;
							font-size: 12px;
							color: #333;
							text-align: right;
							padding-right: 24px;
							box-sizing: border-box;
						}
					}
				}
			}
			.ttshop_myorderpage{
				width: 100%;
				margin-top: 32px;
				.ttshop_pages{
					float: right;
				}
			}
		}
	}
	.ttshop_integral{
		width: 100%;
		height: 334px;
		background: #fff;
		.ttshop_integraltitle{
			width: 100%;
			height: 40px;
			border-bottom: 1px solid #F2F2F2;
			padding: 0 20px;
			box-sizing: border-box;
			h4{
				float: left;
				font-size: 16px;
				color: #999;
				font-weight: 500;
				line-height: 40px;
			}
			a{
				float: right;
				font-size: 12px;
				color: #666;
				font-weight: 400;
				line-height: 40px;
				transition: .5s;
				-moz-transition: .5s;
				-webkit-transition: .5s;
				-o-transition: .5s;
				&:hover{
					color: #FF0E25;
				}
			}
		}
		.ttshop_integralist{
			width: 100%;
			padding: 20px 20px 32px 20px;
			box-sizing: border-box;
			ul{
				li{
					float: left;
					width: 164px;
					margin-right: 32px;
					cursor: pointer;
					&:last-child{
						margin-right: 0;
					}
					.ttshop_integralimg{
						width: 164px;
						height: 164px;
						overflow: hidden;
						margin-bottom: 16px;
						img{
							display: block;
							width: 100%;
							height: 100%;
							object-fit: cover;
							transition: .5s;
							-moz-transition: .5s;
							-webkit-transition: .5s;
							-o-transition: .5s;
						}
					}
					.ttshop_integraltext{
						width: 100%;
						h5{
							font-size: 12px;
							color: #666;
							font-weight: 400;
							line-height: 18px;
							margin-bottom: 10px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							overflow: hidden;
							transition: .5s;
							-moz-transition: .5s;
							-webkit-transition: .5s;
							-o-transition: .5s;
						}
						p{
							.ttshop_integraljf{
								font-size: 12px;
								color: #999;
								strong{
									font-size: 16px;
									color: #FF0E25;
									font-weight: 500;
									margin-right: 4px;
								}
							}
							i{
								display: inline-block;
								width: 12px;
								height: 12px;
								background: url(../../assets/images/ttshop_adds.png) center no-repeat;
								margin: 0 4px;
							}
							.ttshop_integralmoney{
								font-size: 16px;
								color: #FF0E25;
								font-weight: 500;
							}
						}
					}
					&:hover .ttshop_integralimg img{
						-webkit-transform: scale(1.2);
						-moz-transform: scale(1.2);
						-o-transform: scale(1.2);
						-ms-transform: scale(1.2);
						transform: scale(1.2);
					}
					&:hover .ttshop_integraltext h5{
						color: #FF0E25;
					}
				}
			}
		}
	}
</style>
